import styled from 'react-emotion';
import { BoxDiv } from './box';

export const TextContent = styled(BoxDiv)`
  padding: 32px 40px;
  font-size: 29px;
  color: #595959;
  line-height: 46px;
  text-align: justify;
  page-break-inside: avoid;
`;

export const TitlelessTextContent = styled(TextContent)`
  @media print {
    padding: 32px 0;
  }
`;




// WEBPACK FOOTER //
// ./src/components/text-content.jsx